import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import { colorOf } from "../../utils/propTypes";
import css from "./Typography.module.css";
import { DEFAULT_ELEMENT } from "./defaultElements";

const Typography = React.forwardRef(
  (
    {
      variant = "body-lg",
      as,
      color = "default",
      weight = "default",
      align,
      truncate = false,
      clamp,
      className,
      style,
      children,
      ...rest
    },
    ref,
  ) => {
    const Element = as || DEFAULT_ELEMENT[variant] || "span";

    const classes = clsx(
      css[variant],
      css[`color-${color}`],
      weight !== "default" && css[`weight-${weight}`],
      align && css[`align-${align}`],
      truncate && css.truncate,
      clamp && css.clamp,
      className,
    );

    const mergedStyle = clamp ? { ...style, "--line-clamp": clamp } : style;

    return (
      <Element ref={ref} className={classes} style={mergedStyle} {...rest}>
        {children}
      </Element>
    );
  },
);

Typography.displayName = "Typography";

Typography.propTypes = {
  variant: PropTypes.oneOf([
    "display-lg",
    "display-md",
    "display-sm",
    "headline-lg",
    "headline-md",
    "headline-sm",
    "title-lg",
    "title-md",
    "title-sm",
    "body-lg",
    "body-md",
    "body-sm",
    "label-lg",
    "label-md",
    "label-sm",
  ]),
  as: PropTypes.elementType,
  color: colorOf(
    "default",
    "variant",
    "primary",
    "error",
    "success",
    "inherit",
  ),
  weight: PropTypes.oneOf(["default", "bold"]),
  align: PropTypes.oneOf(["start", "center", "end"]),
  truncate: PropTypes.bool,
  clamp: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

export default Typography;
